import React, { Component } from 'react';
import { withStyles, Input, Button } from '@material-ui/core';
import { Person, Mail, Lock } from '@mui/icons-material';
import { withRouter } from 'react-router-dom';
import common from '~/common';
import Actions from '~/Actions';
import { connect } from 'react-redux';
import 'font.css';

const styles = theme => ({
  row: { height: 47, display: 'flex', justifyContent: 'center', alignItems: 'center' },
  icon: { width: 20, height: 20, color: 'rgba(0, 0, 0, 0.54)', marginRight: 4 },
  input: { width: 328, fontSize: 20, paddingLeft: 8 },
});

class App extends Component {
  state={ account: '', email: '', guideText: '', error: [] }
  componentDidUpdate (preProps) {
    const { checkEmail: preCheckEmail = {} } = preProps;
    const { status: preStatus = '' } = preCheckEmail;
    const { checkEmail = {} } = this.props;
    const { status = '' } = checkEmail;
    if (preStatus !== status && status === '200' && !this.timer) {
      this.timer = setInterval(() => {
        this.second = this.second - 1;
        if (this.second >= 0) { this.setState({ guideText: `導向中...${this.second}` }); } else this.goBack();
      }, 1000);
      this.second = 3;
      this.setState({ guideText: `導向中...${this.second}` });
    }
  }

  componentWillUnmount () {
    this.props.clearPsdKey('CheckEmail');
    if (this.timer)clearInterval(this.timer);
  }

  goBack=() => {
    const { isManage } = this.props;
    this.props.history.push(`${common.rootPath}${isManage ? '/Manage' : ''}/Login`);
  }

  send=() => {
    const { postCheckEmail, clearPsdKey } = this.props;
    const { account, email } = this.state;
    clearPsdKey('CheckEmail');
    this.setState({ error: [] });
    const error = [
      account.length === 0,
      email.length === 0,
    ];
    if (error.indexOf(true) === -1)postCheckEmail({ account, email });
    else this.setState({ error });
  }

  render () {
    const { classes, checkEmail = {} } = this.props;
    const { account, email, guideText, error } = this.state;
    const cansSend = checkEmail.status !== '200';
    return (
      <div style={{ width: '100%', height: '100%', paddingTop: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Lock style={{ width: 20, height: 20 }} />
          <div style={{ marginLeft: 19, fontSize: 18, letterSpacing: 0.1 }}>忘記密碼了嗎？</div>
        </div>
        <div style={{ height: 16 }} />
        <div className={classes.row}>
          <Person className={classes.icon} />
          <Input className={classes.input} placeholder="帳號" inputProps={{ 'aria-label': 'description' }} value={account} onChange={e => this.setState({ account: e.target.value })} />
        </div>
        <div style={{ height: 16 }} />
        <div className={classes.row}>
          <Mail className={classes.icon} />
          <Input className={classes.input} placeholder="電子信箱" inputProps={{ 'aria-label': 'description' }} value={email} onChange={e => this.setState({ email: e.target.value })} />
        </div>
        <div style={{ color: '#FF0000', fontSize: 16, letterSpacing: 0.1 }}>請輸入電子郵件地址，我們將發送重置密碼驗證信。</div>
        <div style={{ height: 35 }}>
          <div style={{ color: 'red', marginTop: 10, display: 'flex', justifyContent: 'center' }}>
            {checkEmail.status === '200' && '驗證信已寄出，請查看您的電子郵件信箱'}
            {checkEmail.status === '200' && <div style={{ marginLeft: 4, color: 'black' }}>{guideText}</div>}
            {error.indexOf(true) > -1 && `${error[0] ? '[帳號]' : ''}${error[1] ? '[電子信箱]' : ''}不可為空`}
            {Object.keys(checkEmail).length > 0 && checkEmail.status !== '200' && (checkEmail.message)}
          </div>
        </div>
        <div style={{ display: 'flex', paddingLeft: 304 }}>
          <div style={{ cursor: 'pointer', color: 'rgba(0, 0, 0, 0.54)', fontSize: 18, height: 24, textAlign: 'center' }} onClick={this.goBack}>返回登入頁</div>
        </div>
        <div style={{ height: 19 }} />
        <Button className='Roboto' disabled={!cansSend} style={{ width: 209, height: 48, borderRadius: 5, backgroundColor: cansSend ? '#247690' : 'gray', color: 'white', fontSize: 16, letterSpacing: 0.1 }} onClick={this.send}>
          發送驗證信
        </Button>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  checkEmail: state.PSD.CheckEmail,
  isManage: state.isManage,
});
const mapDispatchToProps = dispatch => ({
  postCheckEmail: body => Actions.postCheckEmail(dispatch, { body }),
  clearPsdKey: key => Actions.clearPsdKey(dispatch, { key }),
});
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
